import { render, staticRenderFns } from "./RelatedItemsModal.vue?vue&type=template&id=1aeb3214"
import script from "./RelatedItemsModal.vue?vue&type=script&lang=js"
export * from "./RelatedItemsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4220330617/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1aeb3214')) {
      api.createRecord('1aeb3214', component.options)
    } else {
      api.reload('1aeb3214', component.options)
    }
    module.hot.accept("./RelatedItemsModal.vue?vue&type=template&id=1aeb3214", function () {
      api.rerender('1aeb3214', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/features/RelatedItemsModal.vue"
export default component.exports